export default function VideoService(
  $http,
  CreativeService,
  DataService,
  RenderService
) {
  return {
    processAndRender,
    ready
  };

  function ready() {
    if (
      CreativeService.creative.action !== 'hosted-video' &&
      CreativeService.creative.action !== 'outstream'
    ) {
      return true;
    }

    if (
      CreativeService.creative.vastTag &&
      CreativeService.creative.vastTag.length > 0
    ) {
      return true;
    }

    return (
      // Status starts as undefined when no upload
      !CreativeService.creative.status ||
      CreativeService.creative.status === 'complete'
    );
  }

  function processAndRender() {
    if (!CreativeService.creative.id) {
      setTimeout(processAndRender, 10000);
      return;
    }

    return $http
      .get(`/creative_previews/${CreativeService.creative.id}/video_status`)
      .then(({ data }) => {
        if (data.status !== 'complete') {
          setTimeout(processAndRender, 10000);
          return;
        }

        return DataService.getCreative(CreativeService.creative.id).then(
          ({ data }) => {
            RenderService.enabled = true;
            CreativeService.setVideoAttributes(data);
          }
        );
      });
  }
}

VideoService.$inject = [
  '$http',
  'CreativeService',
  'DataService',
  'RenderService'
];
